import { useQuery } from '@tanstack/react-query';
import { getFaqs } from './FaqService';

const FAQ_QUERY_KEY = 'faqs';

export const getFaqsQueryKey = (lang) => [FAQ_QUERY_KEY, lang];

export const useFaqs = (lang = 'es') => {
  return useQuery({
    queryKey: getFaqsQueryKey(lang),
    queryFn: () => getFaqs({ lang }),
    staleTime: 5 * 60 * 1000,
    retry: 1,
  });
};
